export const horseQueryKeys = {
  all: (): string => "horse",
  locationList: (): string => "horse:list:location",
  detail: (horseId?: string): string => `horse:detail:${horseId}`,
  aggregatedComments: (horseId?: string): string =>
    `horse:aggregated-comments:${horseId}`,
  aggregatedCommentsInfinite: (horseId?: string): string =>
    `horse:aggregated-comments:infinite:${horseId}`,
  relevantWarningMessage: (horseId?: string): string =>
    `horse:relevant-warning-message:${horseId}`
};
